//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageCopyright from '../Partials/ImageCopyright.vue';

export default {
    name: 'ImageTwoCol',
    components: { ImageCopyright },
    props: ['data'],
    computed: {
        images() {
            return [1, 2].map((i) => {
                const image = this.data?.[`image${i}`]?.image;

                if (!image) return null;

                return {
                    index: i,
                    caption: this.data?.[`imageCaption${i}`],
                    ...this.$mapImageData(image),
                };
            });
        },
    },
};
